import axios from 'axios';
import CONNECTION from '@/app/modules/login/api/apiUrls';
import compareSimilarUrls from '@/common-utils/functions/compareSimilarUrls';
import useSessionStore from '@/app/store/session';
import useVersionsStore from '@/app/store/versions';

const configParameters = require('../../../../package.json');

const client = (() => {
    return axios.create({
        baseURL: '/api',
        headers: {
            Accept: 'application/json, text/plain, */*'
        }

    });
})();


client.interceptors.response.use(
    response => {
        const xLocation = response.headers['x-location'];

        useVersionsStore.getState().setVersions({
            bomo: configParameters.version,
            back: response.headers['x-api-version'],
            customPay: configParameters.versionCustomPay
        });

        if (response.status === 204 && xLocation) {
            if (compareSimilarUrls(response.config.url, CONNECTION.CONNECT_AS.url)) {

                if (xLocation.startsWith(window.location.origin)) {
                    //  Clear session
                    useSessionStore.getState().storeSession(null);
                    // Relaod Session
                    window.location.replace(xLocation);
                } else {
                    // New tab
                    window.open(xLocation, '_blank');
                }
            } else {
                window.location.replace(xLocation);
            }
        }
        return response;
    },
    error => Promise.reject(error)
);

export { client };